import { Fragment, useState } from "react";
import { Menu, Transition } from "@headlessui/react";
import {
  AcademicCapIcon,
  ReceiptRefundIcon,
  CashIcon,
  ClockIcon,
  BadgeCheckIcon,
  UsersIcon,
} from "@heroicons/react/solid";
import "./style.css";
import { IoChevronBackOutline } from "react-icons/io5";


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Discord() {
  const [isOpenNft0, setIsOpenNft0] = useState(false);
  const [isOpenNft1, setIsOpenNft1] = useState(false);
  const [isOpenNft2, setIsOpenNft2] = useState(false);
  const [isOpenNft3, setIsOpenNft3] = useState(false);
  const [isOpenNft4, setIsOpenNft4] = useState(false);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-neutral-900">
       <div class="page-bg animation-wrapper">
        <div class="particle particle-1"></div>
      </div>
      <div className="mx-auto py-12 px-4 max-w-7xl sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-6">
        <h1 class="text-white mt-2 block uppercase text-3xl leading-8 font-extrabold tracking-tight sm:text-4xl">
        Usando Discord para NFTs
          </h1>
          <h3 class="block text-xl text-violet-600 font-semibold tracking-wide ">
          ¿Cómo mantenerse seguro al usar Discord para los NFTs?
          </h3>

          <a href="/learn" className="font-bold ml-2 text-left flex text-white">
            <IoChevronBackOutline className="mr-2 mt-1" /> volver 
            </a>
          <ul role="list" class="space-y-3 text-left">
            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft0(!isOpenNft0)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">¿Qué es Discord?</h2>
                <svg
                  className={`${
                    isOpenNft0
                    ? "rotate-180 h-6 w-6 transform text-gray-400"
                    : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft0}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Discord es una aplicación gratuita de mensajería de voz,
                      vídeo y texto que utilizan las personas para hablar y
                      pasar el rato con sus comunidades y amigos. En el caso de
                      Web3, es una{" "}
                      <strong>
                        plataforma en la que fundadores, creadores, artistas,
                        usuarios de criptomonedas y otros miembros de la
                        comunidad interactúan a diario.
                      </strong>{" "}
                      Cada Discord individual al que te unes se llama servidor y
                      dentro del servidor, hay categorías con #s llamados
                      canales. Estos canales pueden formarse en torno a temas,
                      intereses y objetivos de proyectos, por nombrar algunos,
                      creando mini salas de chat que ayudarán a organizar el
                      flujo de la discusión en un servidor.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft1(!isOpenNft1)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  ¿Por qué la gente usa Discord?
                </h2>
                <svg
                  className={`${
                    isOpenNft1
                    ? "rotate-180 h-6 w-6 transform text-gray-400"
                    : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft1}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      La gente utiliza Discord porque es la plataforma de
                      mensajería preferida por la mayoría de los proyectos de
                      Web3, incluidos los NFTs.
                      <strong>
                        {" "}
                        En los servidores de los proyectos es donde se almacena
                        y se comparte información valiosa para los miembros, y
                        también es donde los miembros de la comunidad
                        interactúan y forman vínculos
                      </strong>
                      . Si estás pensando en comprar una pieza de Cryptonikas,
                      te conviene conocer primero la comunidad uniéndote al
                      servidor. Una vez que estés dentro, podrás chatear con
                      otros miembros y hablar sobre lo que les gusta del arte de
                      CKS, lo que les gusta del proyecto, lo que les hizo unirse
                      al espacio NFT, etc. Si no quieres chatear, puedes
                      simplemente observar la cultura de la comunidad y leer
                      toda la valiosa información disponible en sus canales para
                      hacerte una idea del proyecto.{" "}
                    </p>
                    <p>
                      Dentro de Discord, también tienes la posibilidad de enviar
                      mensajes privados a la gente, lo que se conoce comúnmente
                      como "DM", abreviatura de mensaje directo. Aunque esta
                      función es útil, también es la forma en que muchos son
                      estafados en Web3.{" "}
                      <strong>
                        ¡Es mejor no hacer nunca clic en los enlaces de los DMs
                        de personas que no conoces! Los miembros del equipo de
                        un proyecto tampoco te enviarán nunca un DM primero.
                      </strong>
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft2(!isOpenNft2)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  ¿Cómo me uno a Discord?
                </h2>
                <svg
                  className={`${
                    isOpenNft2
                    ? "rotate-180 h-6 w-6 transform text-gray-400"
                    : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft2}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Se puede acceder a Discord como una aplicación a través de
                      un navegador en tu PC o Mac, o en tu dispositivo móvil.
                      Para empezar, regístrate para obtener una cuenta en:{" "}
                      <a
                        style={{ color: "blue" }}
                        href="https://discord.com/register"
                        target="_blank"
                      >
                        https://discord.com/register/
                      </a>
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft3(!isOpenNft3)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  ¿Cómo me uno al Discord de un proyecto NFT?
                </h2>
                <svg
                  className={`${
                    isOpenNft3
                    ? "rotate-180 h-6 w-6 transform text-gray-400"
                    : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft3}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <p>
                      Después de registrarte en Discord, es el momento de unirte
                      a tu primer servidor. La primera pantalla que aparece te
                      pedirá que crees un servidor de Discord, o puedes hacer
                      clic hacia la parte inferior donde aparece "¿Ya tienes una
                      invitación?" y ahí es donde pegas o escribes el enlace de
                      invitación al proyecto. También puedes visitar las páginas
                      de las redes sociales del proyecto para unirte utilizando
                      el enlace de invitación a su servidor.{" "}
                      <strong>
                        Utiliza sólo los enlaces oficiales que se encuentran en
                        las páginas de las redes sociales del proyecto.
                      </strong>
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>

            <li className="bg-white shadow overflow-hidden rounded-md px-6 py-4">
              <span
                onClick={() => setIsOpenNft4(!isOpenNft4)}
                className="p-4 h-14 flex justify-between cursor-pointer"
              >
                <h2 className="font-bold text-gray-900">
                  Consejos generales de seguridad
                </h2>
                <svg
                  className={`${
                    isOpenNft4
                    ? "rotate-180 h-6 w-6 transform text-gray-400"
                    : "rotate-360 h-6 w-6 transform text-gray-400"
                  }`}
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </span>
              <Transition
                show={isOpenNft4}
                enter="transition-opacity duration-75"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="transition-opacity duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="px-6 mt-4 pt-6 py-y border-t">
                  <div className="grid gap-6 grid-cols-1 md:grid-cols-1">
                    <strong>
                      <p>Desactivar los mensajes directos</p>
                    </strong>
                    <p>
                      Al igual que el correo spam que odias, a menudo recibirás
                      Mensajes Directos al unirte a los servidores de otros
                      miembros de tu comunidad.{" "}
                    </p>

                    <p>
                      <strong>
                        Se recomienda fuertemente que desactives la opción
                        "Permitir mensajes directos de los miembros del
                        servidor" que se encuentra en la Configuración de la
                        privacidad. 
                      </strong>{" "}
                      Esto te ayuda a evitar el contacto de posibles entidades
                      maliciosas y te permite esencialmente elegir con quién te
                      relacionas, porque la interacción por mensaje directo
                      requiere entonces un estado mutuo de "amigo añadido".
                    </p>
                    <p>
                      <strong>
                        Ser precavido con los enlaces en los que se hace clic. {" "}
                      </strong>
                      Asegúrate siempre de que haces clic en el enlace correcto.
                      La mayoría de los servidores de Discord de los proyectos
                      cuentan con un canal llamado “Enlaces Oficiales”. Este es
                      siempre el lugar para comprobar y contiene los únicos
                      enlaces que quieres usar. Hacer clic en el enlace
                      incorrecto podría significar un desastre para tus activos,
                      por lo que siempre debes tener más cuidado, incluyendo la
                      desactivación de los mensajes directos, a menos que ambas
                      partes se hayan agregado como amigos en Discord.
                    </p>
                    <p>
                      <strong>Minteos silenciosos. </strong>
                      Cuando una colección realiza un minteo silencioso, es
                      básicamente una sorpresa. Pueden lanzarse en cualquier
                      momento sin que se anuncie a sus miembros una fecha y hora
                      previamente programadas, y generalmente se ejecutan por
                      orden de llegada. Este es probablemente el método menos
                      común de lanzar un proyecto y es más que probable que sea
                      una estafa.
                    </p>
                    <p>
                      <strong>Hackeos de Discord. </strong>
                      Cuando un discord es hackeado, lo mejor es no entrar en
                      pánico. Normalmente los indicios son un spam de anuncios
                      que etiquetan a todos los miembros afirmando que el
                      proyecto está minteando y proporcionando un enlace para
                      conectar tu cartera diferente de los que se encuentran en
                      los enlaces oficiales (publicados en una fecha anterior).
                      Otro indicio a tener en cuenta es cuando una cuenta
                      autorizada, como un administrador o moderador, empieza a
                      enviar enlaces en el chat y desactiva el acceso a otros
                      miembros del equipo.
                    </p>
                    <p>
                      <strong>
                        NO CONECTES TU CARTERA SI CREES QUE DISCORD HA SIDO
                        HACKEADO Y ABANDONA DISCORD PARA MAYOR SEGURIDAD.
                      </strong>
                    </p>
                    <p>
                      Una vez que el equipo del proyecto tenga la situación bajo
                      control, podrás volver a unirte.
                    </p>
                    <br />
                  </div>
                </div>
              </Transition>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
